<template lang='pug'>
  v-container(v-if='user')
    v-card.mb-4
      v-card-title
        img.image.mr-2(src='/img/logos/github.png')
        .text-h5.font-weight-light GitHub
      v-card-text
        git-hub-install(v-if='!gitHubInstalled')
        git-hub-config(v-if='gitHubInstalled')
    v-card.mb-4
      v-card-title
        img.image.mr-2(src='/img/logos/slack.png')
        .text-h5.font-weight-light Slack
      v-card-text
        slack-config
    v-card.mb-4
      v-card-title
        img.image.mr-2(src='/img/logos/webhook.png')
        .text-h5.font-weight-light Webhook Configuration
      v-card-text
        webhook-config
</template>

<script>
import {get} from 'lodash';
import {mapGetters, mapActions} from 'vuex';
import GitHubInstall from '../../../components/GitHubInstall';
import GitHubConfig from '../../../components/GitHubConfig';
import SlackConfig from '../../../components/SlackConfig';
import WebhookConfig from '../../../components/WebhookConfig';

export default {
  name: 'Integrations',
  components: {WebhookConfig, SlackConfig, GitHubConfig, GitHubInstall},
  async mounted() {
    await this.getUser();
    await this.getAccount(this.user);
  },
  computed: {
    gitHubInstalled() {
      return get(this.account, 'githubInstallationId');
    },
    ...mapGetters({
      user: 'getUser',
      account: 'getAccount'
    })
  },
  methods: {
    ...mapActions({getAccount: 'getAccount', getUser: 'getUser'})
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .image {
    height: 30px;
  }
</style>
